<template>
  <div>
    <v-btn
      class="hil-fab"
      dark
      fab
      color="accent"
      @click="$emit('showAddDialog')"
      style="z-index: 100000"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-sheet elevation="1" class="header-bar">
      <v-layout row class="align-center" wrap>
        <v-flex xs12 lg6>
          <v-text-field
            label="Recherche..."
            append-icon="search"
            v-model="search"
            @input="$emit('update', { search, view, filters })"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 lg4 class="d-inline-flex justify-end d-flex-initial">
          <FiltersGroup
            :choices="{
              available: 'Disponibles',
              'not-available': 'Non disponibles'
            }"
            v-model="filters"
            @input="$emit('update', { search, view, filters })"
          ></FiltersGroup>
        </v-flex>
        <v-flex
          xs2
          class="justify-end d-flex d-flex-initial"
          v-if="$mq !== 'sm'"
        >
          <v-btn-toggle
            v-model="view"
            mandatory
            @input="$emit('update', { search, view, filters })"
          >
            <v-btn flat @input="$emit('update', { search, view, filters })">
              <v-icon>list</v-icon>
            </v-btn>
            <v-btn flat @input="$emit('update', { search, view, filters })">
              <v-icon>grid_on</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-sheet>
  </div>
</template>

<script>
import { DEFAULT_HOST_FILTERS_SETTINGS } from "../data/DefaultSettings";
import FiltersGroup from "./commons/FiltersGroup";

export default {
  name: "HostsFilter",
  components: { FiltersGroup },
  data: function() {
    return DEFAULT_HOST_FILTERS_SETTINGS;
  }
};
</script>

<style scoped>
.d-flex-initial > * {
  flex: initial !important;
}
</style>
